import ServicosService from "../ServicosService";

export default {
  mixins: [ServicosService],
  data() {
    return {
      idRnpPrestador: -1,
      clickSwitch: false,
      listaPublicoAlvo: [],
      id: this.servico.id,

      constantes: {
        strErroServEspacoViverBem: "campoOutrosCentroMultiprofissionalViverBem",
        strErroServOutros: "campoOutrosOutros",
        strErroEspacoViverBem: "outrosCentroMultiprofissionalViverBem",
        strErroOutros: "outrosOutros",
        msgCampoObr: "Este campo é Obrigatório!",
        msgServObr: "Selecione ao menos 1 serviço",
        strServOutros: "Outros",
        strEspacoViverBem: "Espaço Viver Bem",
        strOutros: "Outros"
      }
    };
  },
  beforeMount() {
    this.inicializarPublicoAlvo();
    this.recuperarIdRnpPrestador();
  },
  props: {
    servico: {
      type: Object,
      required: true
    },
    dadosServidor: {
      type: Object
    }
  },
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  methods: {
    toggleSwitch() {
      this.clickSwitch = !this.clickSwitch;
    },
    recuperarIdRnpPrestador() {
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
    },
    inicializarPublicoAlvo() {
      return this.getPublicoAlvo(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaPublicoAlvo = [...data];
        }
      });
    },
    emitPayload(payloadModificado) {
      this.$emit("colher-payload", payloadModificado);
    },
    preencheCampo(campo, payload) {
      if (!payload) return;
      if (campo === "publico") {
        this.payload.tipoServicoPublico = payload;
      }
      if (campo === "abrangencia") {
        this.payload.tipoServicoAbrangencia.push(payload);
      }
      if (campo === "servicoPublico") {
        this.payload.tipoServicoPublico.push(payload);
      }
      if (campo === "especialidade") {
        this.payload.tipoServicoEspecialidade.push(payload);
      }
      if (campo === "outro") {
        this.payload.outro = payload;
      }
      if (campo === "leitos") {
        this.payload.numeroLeitosObservacao = payload;
      }
      if (campo === "especialidades oferecidas") {
        this.payload.especialidadesOferecidas = payload;
      }
    },
    validaCampos(strServico, strErroServ, strMsgErro) {
      const habilitado = this.payload.tipoServico.includes(strServico);

      if (habilitado) {
        const objServico = this.payload;

        const ehObjServicoOutros = objServico.tipoServico.includes(
          this.constantes.strOutros
        );

        const temEspecialidade = ehObjServicoOutros
          ? objServico.especialidadesOferecidas &&
            objServico.especialidadesOferecidas.length > 0
          : objServico.tipoServicoEspecialidade &&
            objServico.tipoServicoEspecialidade.length > 0;

        const temOutros =
          objServico.outro != null && objServico.outro.length > 0;

        const temServicoOutro =
          objServico.tipoServicoEspecialidade &&
          objServico.tipoServicoEspecialidade.some(especialidade => {
            if (!especialidade.tipoServicoEspecialidade) {
              return false;
            }
            if (Array.isArray(especialidade.tipoServicoEspecialidade)) {
              return especialidade.tipoServicoEspecialidade.some(tp =>
                tp.includes(this.constantes.strServOutros)
              );
            } else {
              return especialidade.tipoServicoEspecialidade.includes(
                this.constantes.strServOutros
              );
            }
          });

        if (!temEspecialidade && this.clickSwitch) {
          if (ehObjServicoOutros) {
            this.errorsServicos[strErroServ] = this.constantes.msgCampoObr;
          } else {
            this.mensagemDeErroServicos[
              strMsgErro
            ] = this.constantes.msgServObr;
          }
        } else {
          if (ehObjServicoOutros) {
            this.errorsServicos[strErroServ] = "";
          } else {
            this.mensagemDeErroServicos[strMsgErro] = "";
          }

          if (temServicoOutro && !temOutros) {
            this.errorsServicos[strErroServ] = this.constantes.msgCampoObr;
          } else {
            this.errorsServicos[strErroServ] = "";
          }
        }
      }
    },
    desabilitaErros(newValServico) {
      if (this.payload.tipoServico.includes(newValServico.tipoServico)) {
        if (
          newValServico.tipoServico.includes(this.constantes.strLaboratorio)
        ) {
          this.mensagemDeErroServicos[this.constantes.strMsgErroLaboratorio] =
            "";
          this.errorsServicos[this.constantes.strErroServLaboratorio] = "";
        }
        if (
          newValServico.tipoServico.includes(
            this.constantes.strCentroDiagnostico
          )
        ) {
          this.mensagemDeErroServicos[
            this.constantes.strErroCentroDiagnostico
          ] = "";
          this.errorsServicos[this.constantes.strErroServCentroDiagnostico] =
            "";
        }
        if (
          newValServico.tipoServico.includes(this.constantes.strPostoColeta)
        ) {
          this.mensagemDeErroServicos[this.constantes.strErroPostoColeta] = "";
          this.errorsServicos[this.constantes.strErroServPostoColeta] = "";
        }
        this.validaErrors();
      }
    },
    chequeOutros() {
      if (!this.errorsServicos) return;

      this.validaCampos(
        this.constantes.strEspacoViverBem,
        this.constantes.strErroServEspacoViverBem,
        this.constantes.strErroEspacoViverBem
      );

      this.validaCampos(
        this.constantes.strOutros,
        this.constantes.strErroServOutros,
        this.constantes.strErroOutros
      );

      this.validaErrors();
    },
    validaErrors() {
      let temErro = false;

      Object.values(this.errorsServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      Object.values(this.mensagemDeErroServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      return temErro;
    },
    emitir() {
      if (!this.outrosOpcao) {
        this.payload.outro = "";
      }
      this.chequeOutros();
      this.emitPayload({ ...this.payload, clickSwitch: this.clickSwitch });
    }
  },
  watch: {
    temErrors(boo) {
      const payload = {
        temErro: boo,
        validacaoId: this.validacaoId
      };
      this.$emit("error", payload);
    },
    clickSwitch(newVal) {
      const newValObj = {
        clickSwitch: newVal,
        tipoServico: this.payload.tipoServico
      };
      if (!newVal) {
        (this.payload.tipoServicoEspecialidade = []),
          (this.payload.tipoServicoPublico = null),
          (this.payload.tipoServicoAbrangencia = []),
          (this.payload.especialidadesOferecidas = ""),
          (this.payload.numeroLeitosObservacao = ""),
          (this.payload.outro = "");
        this.desabilitaErros(newValObj);
      } else {
        this.chequeOutros();
      }

      this.$emit("switch", newValObj);
    },
    "payload.tipoServicoEspecialidade": function() {
      if (!this.payload.tipoServicoEspecialidade) {
        return (this.outrosOpcao = false);
      }

      let arr = [];
      this.payload.tipoServicoEspecialidade.map(el => {
        arr.push(el.tipoServicoEspecialidade);
      });
      arr.find(especialidades => {
        if (especialidades.includes("Outro")) {
          this.outrosOpcao = true;
          return true;
        } else {
          this.outrosOpcao = false;
          return false;
        }
      });
      this.emitir();
    }
  }
};
